<template>
  <Form 
    :d_form='form'
    :d_se_pengeluaran='se_pengeluaran'
    v-if="id > 0 && load == 2"
  /> 
  <Form 
    :d_form='form'
    :d_se_pengeluaran='se_pengeluaran'
    v-else-if="id == 0 && load == 1"
  /> 
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import Form from "./_From.vue";

export default {
  extends: ZResource,
  components: {
    Form
  },
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'se.pemungutan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Pemungutan Pendaftaran IBVK', route: '/se/pemungutan' },
      ],
      title : 'Tambah Baka Jantan',
      form : {
        id : 0,
        tarikh : '',
        no_batch: '',
        tarikh_pengeluaran : 0,
        id_ternakan : '',
        nama_ternakan: '',
        baka: '',
        negara : '',
        jumlah_straw: '',
        harga:0,
        hantar: 2
      },
      form1:[],
      se_pengeluaran : [],
      negeri: [],
      load : 0
      
      
    }
  },
  methods: {
    
    getGetnoBatch(){
      this.$zcomm.get(this.api_service + 'se_pendaftaran/get', {}).then(res => {
        this.se_pengeluaran = res
        this.load = this.load + 1
      })
    },
 
    getData(){
      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'se_pendaftaran/show/'+this.id, {}).then(res => {
          this.form = res
          this.load = this.load + 1

        })
      }
    },
  
  },

  watch: {

  },
  mounted() {
    this.getData();
    this.getGetnoBatch()
    
  }
    
}
</script>
